import { ROUTES } from "../../../api/api.routes";
import useCustomQuery, { QueryOpts } from "../../../hooks/useQuery";
import { useSearchUrl } from "../../../hooks/useSearch";
import { Doc } from "../../../types/db/collections";
import { GetProductDto } from "../../../types/db/schema/products/product.schema";

export const useProducts = (o?: QueryOpts) => {
  const { urlWithFilter } = useSearchUrl();

  const { data, isLoading, isRefetching, mutate } = useCustomQuery<Doc<GetProductDto>[]>(
    urlWithFilter(ROUTES.Products.All),
    o
  );

  return {
    products: data,
    isLoading,
    isRefetching,
    mutate
  }
}